module.exports = global["L"] = require("-!./leaflet-src.js");